import React, { useState } from 'react';
import axios from 'axios';
import AnimatedLogo from '../components/AnimatedLogo';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AdminLogin = ({ onLogin }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const response = await axios.post(`${API}/admin/login`, { username, password });
      sessionStorage.setItem('admin_token', response.data.token);
      onLogin();
    } catch {
      setError('Invalid username or password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: '#ECEAE3',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '1rem',
      fontFamily: "-apple-system, BlinkMacSystemFont, 'Inter', 'Segoe UI', sans-serif",
    }}>
      <div style={{
        background: '#FFFFFF',
        border: '1px solid rgba(26,24,24,0.10)',
        borderRadius: '20px',
        padding: '2.5rem 2.25rem',
        width: '100%',
        maxWidth: '400px',
        boxShadow: '0 8px 32px rgba(0,0,0,0.08)',
        position: 'relative',
        zIndex: 1,
      }}>
        {/* Logo + brand */}
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: '2rem', gap: '0.75rem' }}>
          <AnimatedLogo />
          <div style={{ textAlign: 'center' }}>
            <div style={{ color: '#1A1A18', fontSize: '1.25rem', fontWeight: 700, letterSpacing: '-0.02em' }}>
              Custodian AI
            </div>
            <div style={{ color: '#8A857A', fontSize: '0.8rem', marginTop: '2px' }}>
              Admin Portal
            </div>
          </div>
        </div>

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '1rem' }}>
            <label style={{
              display: 'block',
              color: '#5A564D',
              fontSize: '0.8rem',
              fontWeight: 500,
              marginBottom: '6px',
              letterSpacing: '0.02em',
            }}>
              Username
            </label>
            <input
              type="text"
              value={username}
              onChange={e => setUsername(e.target.value)}
              required
              autoFocus
              placeholder="Enter username"
              style={{
                width: '100%',
                padding: '0.7rem 0.875rem',
                background: 'rgba(26,24,24,0.04)',
                border: '1.5px solid rgba(26,24,24,0.18)',
                borderRadius: '10px',
                color: '#1A1A18',
                fontSize: '0.9rem',
                outline: 'none',
                boxSizing: 'border-box',
                transition: 'border-color 0.15s',
              }}
              onFocus={e => e.target.style.borderColor = '#C0492A'}
              onBlur={e => e.target.style.borderColor = 'rgba(26,24,24,0.18)'}
            />
          </div>

          <div style={{ marginBottom: '1.75rem' }}>
            <label style={{
              display: 'block',
              color: '#5A564D',
              fontSize: '0.8rem',
              fontWeight: 500,
              marginBottom: '6px',
              letterSpacing: '0.02em',
            }}>
              Password
            </label>
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
              placeholder="Enter password"
              style={{
                width: '100%',
                padding: '0.7rem 0.875rem',
                background: 'rgba(26,24,24,0.04)',
                border: '1.5px solid rgba(26,24,24,0.18)',
                borderRadius: '10px',
                color: '#1A1A18',
                fontSize: '0.9rem',
                outline: 'none',
                boxSizing: 'border-box',
                transition: 'border-color 0.15s',
              }}
              onFocus={e => e.target.style.borderColor = '#C0492A'}
              onBlur={e => e.target.style.borderColor = 'rgba(26,24,24,0.18)'}
            />
          </div>

          {error && (
            <div style={{
              background: 'rgba(239,68,68,0.08)',
              border: '1px solid rgba(239,68,68,0.25)',
              borderRadius: '8px',
              padding: '0.6rem 0.875rem',
              color: '#dc2626',
              fontSize: '0.83rem',
              marginBottom: '1.25rem',
              textAlign: 'center',
            }}>
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            style={{
              width: '100%',
              padding: '0.75rem',
              background: loading ? 'rgba(192,73,42,0.5)' : '#C0492A',
              border: 'none',
              borderRadius: '10px',
              color: '#fff',
              fontSize: '0.9rem',
              fontWeight: 600,
              cursor: loading ? 'not-allowed' : 'pointer',
              transition: 'all 0.2s',
              boxShadow: loading ? 'none' : '0 4px 14px rgba(192,73,42,0.25)',
              letterSpacing: '-0.01em',
            }}
          >
            {loading ? 'Signing in…' : 'Sign in'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
